import { determineResultProgress, progressTypes } from './progressCalculator';

export const sortBy = {
  rating: 'rating',
  averagePercentage: 'average_percentage',
};

const sortByName = (tag_a, tag_b) =>
  tag_a.name < tag_b.name ? -1 : tag_a.name > tag_b.name ? 1 : 0;

const sortTags = (tags, course, sortBySelection) => {
  const categories = {};
  categories[progressTypes.STRENGTH] = [];
  categories[progressTypes.PROGRESSING] = [];
  categories[progressTypes.OPPORTUNITY_FOR_GROWTH] = [];

  tags.forEach((tag) => {
    const scoring =
      sortBySelection === sortBy.rating
        ? tag.status.rating
        : tag.average_percentage;
    const tagCategory = determineResultProgress(scoring, course);
    categories[tagCategory].push(tag);
  });

  categories[progressTypes.STRENGTH].sort(sortByName);
  categories[progressTypes.PROGRESSING].sort(sortByName);
  categories[progressTypes.OPPORTUNITY_FOR_GROWTH].sort(sortByName);

  return [
    ...categories[progressTypes.OPPORTUNITY_FOR_GROWTH],
    ...categories[progressTypes.PROGRESSING],
    ...categories[progressTypes.STRENGTH],
  ];
};

export default sortTags;
